import React from 'react'
import PropTypes from 'prop-types'
import Datetime from 'react-datetime'
import { getYear } from '../Utils/cvDataHelpers'
import Trash from 'react-feather/dist/icons/trash.js'
import 'react-datetime/css/react-datetime.css'

const DiplomasSection = ({
  isOpen,
  toggleSection,
  combinedDiplomas,
  openDiplomas,
  toggleDiploma,
  selectedDiplomas,
  handleSelectionChange,
  handleDiplomaInputChange,
  handleDelete,
  isRegistrationFlow,
}) => {
  const renderYearPicker = (value, onChange, disabled) => {
    return (
      <Datetime
        value={value ? getYear(value).toString() : ''}
        onChange={(date) => {
          const year = typeof date === 'string' ? date : date.format('YYYY')
          onChange(`${year}-01-01 01:00:00`)
        }}
        viewMode="years"
        dateFormat="YYYY"
        timeFormat={false}
        closeOnSelect={true}
        initialViewMode="years"
        inputProps={{
          className: 'form-control',
          disabled: disabled,
          placeholder: 'aaaa'
        }}
      />
    )
  }

  return (
    <div className="mb-5">
      <div className="mb-3 d-flex align-items-center" onClick={() => toggleSection('diplomas')} style={{ cursor: 'pointer' }}>
        <span className="form-title-chip rounded-circle mr-2">4</span>

        <h4 className="mb-0">Vos diplômes</h4>

        <span className="ml-auto h3 text-secondary mb-0">{isOpen ? '-' : '+'}</span>
      </div>

      { isOpen && (
        <>
          {combinedDiplomas.length === 0 ? (
            <div className="callout callout-secondary text-center col-md-7 mx-auto">
              Aucun diplôme à comparer.
            </div>
          ) : (
            combinedDiplomas.map((diploma, index) => (
              <div key={diploma._id} className="callout py-3">
                <div className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                  <div className="d-flex align-items-start mr-4 flex-grow-1" onClick={() => toggleDiploma(diploma._id)}>
                    <>
                      {diploma.isIdentical && <span className="badge badge-success mt-1 mr-3">Identique</span>}
                      {diploma.isDifferent && <span className="badge badge-info mt-1 mr-3">Différent</span>}
                      {diploma.isNew && <span className="badge badge-primary text-white mt-1 mr-3">Nouveau</span>}
                      {diploma.isCurrent && <span className="badge badge-secondary mt-1 mr-3">Twineeds</span>}
                    </>

                    <h5 className="mb-0">{diploma.name}</h5>
                  </div>

                  <div className="ml-auto d-flex align-items-center">
                    <button
                      type="button"
                      className="btn btn-outline-danger btn-sm btn-round mr-3"
                      onClick={(e) => {
                        e.stopPropagation()
                        handleDelete('diplomas', index)
                      }}
                    >
                      <Trash/>
                    </button>

                    <span className="h4 text-secondary mb-0" onClick={() => toggleDiploma(diploma._id)}>{openDiplomas[diploma._id] ? '-' : '+'}</span>
                  </div>
                </div>

                { openDiplomas[diploma._id] && (
                  <div className="row mt-3">
                    {/* Analyse Data Column */}
                    {diploma.analyseData && (
                      <div className={`col-md-${diploma.isDifferent ? '6' : '12'}`}>
                        <div className={`p-3 mb-3 border rounded ${diploma.isDifferent && selectedDiplomas[diploma._id] !== 'analyseData' ? 'border-light' : ''}`}>
                          {diploma.isDifferent && (
                            <div className="custom-control custom-switch mb-2">
                              <input
                                className="custom-control-input"
                                type="checkbox"
                                id={`diploma-${diploma._id}-analyse`}
                                checked={selectedDiplomas[diploma._id] === 'analyseData'}
                                onChange={() => handleSelectionChange('diplomas', diploma._id, 'analyseData')}
                              />

                              <label className="custom-control-label" htmlFor={`diploma-${diploma._id}-analyse`}>
                                Nouvelle donnée du CV
                              </label>
                            </div>
                          )}

                          {diploma.analyseData && (
                            <div style={{ opacity: diploma.isDifferent && selectedDiplomas[diploma._id] !== 'analyseData' ? 0.5 : 1 }}>
                              <div className="row">
                                <div className="col-md-8">
                                  <div className="form-group mb-2">
                                    <label htmlFor={`diploma-${diploma._id}-analyse-name`}>École ou formation</label>

                                    <input
                                      type="text"
                                      className="form-control"
                                      id={`diploma-${diploma._id}-analyse-name`}
                                      value={diploma.analyseData.description}
                                      onChange={(e) => handleDiplomaInputChange(index, 'analyseData', 'description', e.target.value)}
                                      disabled={selectedDiplomas[diploma._id] !== 'analyseData'}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="form-group mb-0">
                                    <label>Année d'obtention</label>
                                    {renderYearPicker(
                                      diploma.analyseData.year,
                                      (val) => handleDiplomaInputChange(index, 'analyseData', 'year', val),
                                      selectedDiplomas[diploma._id] !== 'analyseData'
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="form-group mb-2">
                                <label htmlFor={`diploma-${diploma._id}-analyse-description`}>Intitulé du diplôme / formation</label>

                                <textarea
                                  className="form-control"
                                  id={`diploma-${diploma._id}-analyse-description`}
                                  rows="2"
                                  value={diploma.analyseData.name}
                                  onChange={(e) => handleDiplomaInputChange(index, 'analyseData', 'name', e.target.value)}
                                  disabled={selectedDiplomas[diploma._id] !== 'analyseData'}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Freelance Data Column */}
                    {!diploma.isIdentical && (diploma.freelanceData || diploma.isDifferent) && (
                      <div className={`col-md-${diploma.isDifferent ? '6' : '12'}`}>
                        <div className={`p-3 mb-3 border rounded ${diploma.isDifferent && selectedDiplomas[diploma._id] !== 'freelanceData' ? 'border-light' : ''}`}>
                          {diploma.isDifferent && (
                            <div className="custom-control custom-switch mb-2">
                              <input
                                className="custom-control-input"
                                type="checkbox"
                                id={`diploma-${diploma._id}-freelance`}
                                checked={selectedDiplomas[diploma._id] === 'freelanceData'}
                                onChange={() => handleSelectionChange('diplomas', diploma._id, 'freelanceData')}
                              />

                              <label className="custom-control-label" htmlFor={`diploma-${diploma._id}-freelance`}>
                                Donnée actuelle
                              </label>
                            </div>
                          )}

                          {diploma.freelanceData && (
                            <div style={{ opacity: diploma.isDifferent && selectedDiplomas[diploma._id] !== 'freelanceData' ? 0.5 : 1 }}>
                              <div className="row">
                                <div className="col-md-8">
                                  <div className="form-group mb-2">
                                    <label htmlFor={`diploma-${diploma._id}-freelance-name`}>École ou formation</label>

                                    <input
                                      type="text"
                                      className="form-control"
                                      id={`diploma-${diploma._id}-freelance-name`}
                                      value={diploma.freelanceData.description}
                                      onChange={(e) => handleDiplomaInputChange(index, 'freelanceData', 'description', e.target.value)}
                                      disabled={selectedDiplomas[diploma._id] !== 'freelanceData'}
                                    />
                                  </div>
                                </div>

                                <div className="col-md-4">
                                  <div className="form-group mb-0">
                                    <label>Année d'obtention</label>
                                    {renderYearPicker(
                                      diploma.freelanceData.year,
                                      (val) => handleDiplomaInputChange(index, 'freelanceData', 'year', val),
                                      selectedDiplomas[diploma._id] !== 'freelanceData'
                                    )}
                                  </div>
                                </div>
                              </div>

                              <div className="form-group mb-2">
                                <label htmlFor={`diploma-${diploma._id}-freelance-description`}>Intitulé du diplôme / formation</label>

                                <textarea
                                  className="form-control"
                                  id={`diploma-${diploma._id}-freelance-description`}
                                  rows="2"
                                  value={diploma.freelanceData.name}
                                  onChange={(e) => handleDiplomaInputChange(index, 'freelanceData', 'name', e.target.value)}
                                  disabled={selectedDiplomas[diploma._id] !== 'freelanceData'}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            ))
          )}
        </>
      )}
    </div>
  )
}

DiplomasSection.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggleSection: PropTypes.func.isRequired,
  combinedDiplomas: PropTypes.array.isRequired,
  openDiplomas: PropTypes.object.isRequired,
  toggleDiploma: PropTypes.func.isRequired,
  selectedDiplomas: PropTypes.object.isRequired,
  handleSelectionChange: PropTypes.func.isRequired,
  handleDiplomaInputChange: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  isRegistrationFlow: PropTypes.bool.isRequired,
}

DiplomasSection.defaultProps = {
  isRegistrationFlow: false,
}

export default DiplomasSection
